module.exports = __webpack_public_path__ + "media/images/icons/payment-methods/alipay-3c16308d82f3ceceb3dd74c9068cf83d.svg";